export class FarmerLandModel {
    id?:number;
    total_Area?:number;
    Land_ID?:number;
    land_ID?:number;
    landID?: number;
    farmerID?:string;
    morbno?:number;
    killano?:number;
    kanal?:number;
    marla?:number;
    village_Code?:number;
    is_Available_Lease:boolean;
    croptype: number;
    Landdoc_Path: string;
    landdoc_Path: string;
    active: string;
    lat: number;
    long: number;
    lease_Agrement_Doc: string;
    user_ID: string;
    network_ID: string;
    terminal_ID: string;
    delete_Land_record: string;
    Land_Doc: string;
    crop_Datas: any;
    
  }

  export class crop_Datas {
    crop_ID: number;
    type_of_crop_ID: number;
    total_Area: number;
  }

  export class SelectedCropModel {
    Crop_ID: number;
    Type_Of_Crop_ID: number;
    total_Area: number;
  }

  export class FLandModel {
    Id?:number;
    Total_Area?:number;
    Land_ID?:number;
    Farmer_ID?:string;
    Morabba_No?:number;
    Killa_No?:number;
    Kanals?:number;
    Marlas?:number;
    Village_Code?:number;
    IS_Avalibe_for_Lease:boolean;
    croptype: number;
    Landdoc_Path: string;
    Active: string;
    Lat: number;
    Long: number;
    Lease_Agrement_Doc: string;
    User_ID: string;
    Network_Id: string;
    Terminal_Id: string;
    delete_Land_record: string;
    Land_Doc: string;
    crop_Datas: any;
    description: string;
    MorabbaNo: any;
    KillaNo: any;
    LandID: any;
  }
